import { ArrowUpRight, ChevronRight } from "lucide-react";
import { useState, type ReactNode } from "react";

export function DemoAction({ children, message, className = "button button--primary" }: { children: ReactNode; message: string; className?: string }) {
  const [visible, setVisible] = useState(false);
  function activate() {
    setVisible(true);
    window.setTimeout(() => setVisible(false), 2600);
  }
  return <><button className={className} onClick={activate}>{children}</button>{visible && <span className="action-toast" role="status">{message}</span>}</>;
}

export function StatusBadge({ status }: { status: string }) {
  const clean = String(status || "pending").toLowerCase().replace(/[\s-]+/g, "_");
  return <span className={`status status--${clean}`}>{clean.replace(/_/g, " ")}</span>;
}

export function WorkspaceHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="workspace-header">
    <div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{description && <p>{description}</p>}</div>
    {actions && <div className="workspace-actions">{actions}</div>}
  </header>;
}

export function Metric({ label, value, note, tone = "default" }: { label: string; value: string | number; note: string; tone?: "default" | "warning" | "good" }) {
  return <div className={`metric metric--${tone}`}><span>{label}</span><strong>{value}</strong><small>{note}</small></div>;
}

export function EmptyState({ title, body, action }: { title: string; body: string; action?: ReactNode }) {
  return <div className="empty-state"><span className="empty-state__line" /><h2>{title}</h2><p>{body}</p>{action}</div>;
}

export function ListRow({ title, meta, status, detail, onClick }: { title: string; meta: string; status?: string; detail?: string; onClick?: () => void }) {
  const content = <><div className="list-row__main"><strong>{title}</strong><span>{meta}</span>{detail && <small>{detail}</small>}</div>{status && <StatusBadge status={status} />}{onClick ? <ChevronRight size={19} aria-hidden="true" /> : <ArrowUpRight size={18} aria-hidden="true" />}</>;
  return onClick
    ? <button className="list-row" onClick={onClick}>{content}</button>
    : <div className="list-row">{content}</div>;
}

export function LoadingWorkspace() {
  return <div className="loading-workspace" aria-live="polite"><span /><span /><span /><p>Loading current operations…</p></div>;
}
